// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-avatar[data-v-f2a727aa]{width:100%;height:100%;background:#e6e6e6;border-radius:50%;align-items:center;font-size:14px;font-weight:600;color:#dc1253}.no-avatar[data-v-f2a727aa],.profile-avatar[data-v-f2a727aa]{display:flex;justify-content:center}.profile-avatar .no-avatar[data-v-f2a727aa]{width:160px;height:160px;font-size:40px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
